import { render, staticRenderFns } from "./EscolheAreas.vue?vue&type=template&id=0211c985&scoped=true"
import script from "./EscolheAreas.vue?vue&type=script&lang=js"
export * from "./EscolheAreas.vue?vue&type=script&lang=js"
import style0 from "./EscolheAreas.vue?vue&type=style&index=0&id=0211c985&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0211c985",
  null
  
)

export default component.exports